import { useToast } from 'vue-toastification';

let notificationSound: HTMLAudioElement | null = null;

function playSound(): void {
  try {
    if (!notificationSound) {
      notificationSound = new Audio('/sounds/message-notification.mp3');
      notificationSound.volume = 0.5;
    }
    notificationSound.currentTime = 0;
    void notificationSound.play().catch(() => {
      /* Browser blockiert Autoplay ohne Interaktion */
    });
  } catch {
    /* ignore */
  }
}

export interface CommissionRequestPayload {
  type?: string;
  order_id?: number;
  order_number?: string;
  item_count?: number;
  requester_name?: string;
  parts_preview?: string;
  url?: string;
}

export default {
  async requestPermission(): Promise<NotificationPermission | 'unsupported'> {
    if (!('Notification' in window)) {
      return 'unsupported';
    }
    if (Notification.permission === 'granted') {
      return 'granted';
    }
    if (Notification.permission === 'denied') {
      return 'denied';
    }
    return Notification.requestPermission();
  },

  getPermission(): NotificationPermission | 'unsupported' {
    if (!('Notification' in window)) {
      return 'unsupported';
    }
    return Notification.permission;
  },

  notifyNewRequest(
    data: CommissionRequestPayload,
    options: { onNavigate?: () => void; suppressBrowser?: boolean } = {}
  ): void {
    const toast = useToast();
    const orderLabel = data.order_number || `Auftrag #${data.order_id ?? '?'}`;
    const count = data.item_count ?? 1;
    const from = data.requester_name ? ` · ${data.requester_name}` : '';
    const preview = data.parts_preview ? `\n${data.parts_preview}` : '';
    const message = `Neue Kommission: ${orderLabel} (${count} Teil${count === 1 ? '' : 'e'})${from}${preview}`;

    if (
      !options.suppressBrowser &&
      'Notification' in window &&
      Notification.permission === 'granted'
    ) {
      const notification = new Notification('Neue Kommissionsanfrage', {
        body: `${orderLabel} · ${count} Teil(e)${from}`,
        icon: '/favicon.ico',
        tag: `commission-${data.order_id ?? Date.now()}`,
      });
      notification.onclick = () => {
        window.focus();
        options.onNavigate?.();
        notification.close();
      };
    }

    toast.info(message, {
      timeout: 8000,
      onClick: () => options.onNavigate?.(),
    });

    playSound();
  },
};
